import Vue from 'vue';

const success = (context, response) => {
  context.welcome_form_submitted = response.welcome_form_submitted;
  context.checkin_form_submitted = response.checkin_form_submitted;
  toastr.success(context.$t("calendar.booking-detail.form_status_updated"));
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, data) => {
  return Vue.$http.post('bookings/change-form-status', data)
    .then(response => {
      success(context, response.data)
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/form/changeFormStatus.js